import dayjs from 'dayjs';
import { toast } from 'sonner';
import { mkConfig, download, generateCsv } from 'export-to-csv';

type downloadReportInput = {
  data: Record<string, unknown>[];
  fileName?: string;
};

export function downloadReport({ data, fileName = 'report' }: downloadReportInput) {
  try {
    const fileNameUsingDateRangeFromFilters = `${fileName}-${dayjs(new Date()).format(
      'MM-DD-YYYY-h-mm'
    )}`;
    const csvConfig = mkConfig({
      useKeysAsHeaders: true,
      filename: fileNameUsingDateRangeFromFilters,
    });

    // @ts-expect-error data is unknown
    const csv = generateCsv(csvConfig)(data);

    download(csvConfig)(csv);

    toast.success('Report downloaded successfully');
  } catch (error) {
    console.error(error);
    toast.error('Failed to download CSV');
  }
}
